import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableEditVodDetails from './tableEditVodDetails';

export default {
  title: 'VoDBackend work logs',
  attributeName: 'vodDetails',
  fields: [
    {
      attributeName: 'vodDetails',
      type: FormInputTypes.TABLE,
      label: '',
      helpText: '',
      configFile: tableEditVodDetails,
    },
  ],
};
